<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择物料"
      width="1200px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="materials"
        @select="selectMaterial"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter" @keyup.enter.native="loadData()">
          <el-form-item label="关键字" prop="keyWords">
            <el-input v-model.trim="filter.keyWords" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: {TableSelect},
    data() {
      return {
        dialogVisible: false,
        filter: {
          keyWords: "",
        },
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "业务类别",
            key: "businessTypeName",
            align: "center",
            width: 100,
          },
          {
            title: "物料代码",
            key: "materialNO",
            width: 280,
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 280,
          },
          {
            title: "物料规格",
            key: "specification",
            minWidth: 280,
          },
          {
            title: "产品线",
            key: "materialTypeName",
            width: 180,
          },
          {
            title: "状态",
            key: "statusName",
            width: 80,
            align: "center",
          },
        ],
        selections: [],
      };
    },
    methods: {
      open(statusName) {
        this.dialogVisible = true;
        this.temp = statusName;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.filter.statusName = statusName;
          this.$refs.tableSelect.loadData();
        });
      },

      selectMaterial(selections) {
        this.selections = selections;
      },

      submitHandle() {
        this.$emit("select", this.selections);
        this.dialogVisible = false;
      },
      loadData() {
        this.$refs.tableSelect.loadData();
      },
      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.filter.statusName = this.temp;
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
